// extracted by mini-css-extract-plugin
export default {"container":"additional-delivery-info_container__599ab","title":"additional-delivery-info_title__472cc","text":"additional-delivery-info_text__52f59"};